import React from 'react';
import { ChevronDownButton } from './ChevronDownButton';
import { ChevronUpButton } from './ChevronUpButton';
export function ToggleVerticalChevronButton(_ref) {
  let {
    expanded,
    ...props
  } = _ref;
  if (![true, false].includes(expanded)) {
    console.error('The "expanded" state property is required for the ToggleVerticalChevronButton component.');
  }
  return expanded ? /*#__PURE__*/React.createElement(ChevronUpButton, props) : /*#__PURE__*/React.createElement(ChevronDownButton, props);
}